import { create } from "zustand";
import { DEFAULT_LAYOUT, type LayoutId } from "../lib/jsonContracts";
const KEY="axon-tags.layout";
const read=():LayoutId=>{ try{return(localStorage.getItem(KEY) as LayoutId)||DEFAULT_LAYOUT}catch{return DEFAULT_LAYOUT} };
interface S{layoutId:LayoutId;setLayout:(id:LayoutId)=>void;}
export const useLayoutStore=create<S>((set)=>({
  layoutId:read(),
  setLayout:(id)=>{try{localStorage.setItem(KEY,id)}catch{/**/}set({layoutId:id});}
}));
